/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SegmentationSettings
 */
export interface SegmentationSettings {
    /**
     * 
     * @type {boolean}
     * @memberof SegmentationSettings
     */
    showModulesWheel?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SegmentationSettings
     */
    showPersonalMeetings?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SegmentationSettings
     */
    readonly showCompletedActivities?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SegmentationSettings
     */
    showJobInterviews?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SegmentationSettings
     */
    myActivitiesVisible?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SegmentationSettings
     */
    isChatEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SegmentationSettings
     */
    tawkToWidget?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SegmentationSettings
     */
    publishJobProfileSection?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SegmentationSettings
     */
    publishNetworkProfileSection?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SegmentationSettings
     */
    competencesSection?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SegmentationSettings
     */
    experienceSection?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SegmentationSettings
     */
    nextJobSection?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SegmentationSettings
     */
    cvSection?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SegmentationSettings
     */
    progressModuleSectionId?: number;
}

/**
 * Check if a given object implements the SegmentationSettings interface.
 */
export function instanceOfSegmentationSettings(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SegmentationSettingsFromJSON(json: any): SegmentationSettings {
    return SegmentationSettingsFromJSONTyped(json, false);
}

export function SegmentationSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SegmentationSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'showModulesWheel': !exists(json, 'ShowModulesWheel') ? undefined : json['ShowModulesWheel'],
        'showPersonalMeetings': !exists(json, 'ShowPersonalMeetings') ? undefined : json['ShowPersonalMeetings'],
        'showCompletedActivities': !exists(json, 'ShowCompletedActivities') ? undefined : json['ShowCompletedActivities'],
        'showJobInterviews': !exists(json, 'ShowJobInterviews') ? undefined : json['ShowJobInterviews'],
        'myActivitiesVisible': !exists(json, 'MyActivitiesVisible') ? undefined : json['MyActivitiesVisible'],
        'isChatEnabled': !exists(json, 'IsChatEnabled') ? undefined : json['IsChatEnabled'],
        'tawkToWidget': !exists(json, 'TawkToWidget') ? undefined : json['TawkToWidget'],
        'publishJobProfileSection': !exists(json, 'PublishJobProfileSection') ? undefined : json['PublishJobProfileSection'],
        'publishNetworkProfileSection': !exists(json, 'PublishNetworkProfileSection') ? undefined : json['PublishNetworkProfileSection'],
        'competencesSection': !exists(json, 'CompetencesSection') ? undefined : json['CompetencesSection'],
        'experienceSection': !exists(json, 'ExperienceSection') ? undefined : json['ExperienceSection'],
        'nextJobSection': !exists(json, 'NextJobSection') ? undefined : json['NextJobSection'],
        'cvSection': !exists(json, 'CvSection') ? undefined : json['CvSection'],
        'progressModuleSectionId': !exists(json, 'ProgressModuleSectionId') ? undefined : json['ProgressModuleSectionId'],
    };
}

export function SegmentationSettingsToJSON(value?: SegmentationSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ShowModulesWheel': value.showModulesWheel,
        'ShowPersonalMeetings': value.showPersonalMeetings,
        'ShowJobInterviews': value.showJobInterviews,
        'MyActivitiesVisible': value.myActivitiesVisible,
        'IsChatEnabled': value.isChatEnabled,
        'TawkToWidget': value.tawkToWidget,
        'PublishJobProfileSection': value.publishJobProfileSection,
        'PublishNetworkProfileSection': value.publishNetworkProfileSection,
        'CompetencesSection': value.competencesSection,
        'ExperienceSection': value.experienceSection,
        'NextJobSection': value.nextJobSection,
        'CvSection': value.cvSection,
        'ProgressModuleSectionId': value.progressModuleSectionId,
    };
}

